import React, { FC } from "react";
import { FormattedMessage } from "react-intl";

export const DimensionMultiplySymbol: FC = () => (
  <FormattedMessage id="common.dimensionMultiplySymbol" defaultMessage="x" />
);
